import React, { useMemo } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { entityToHref } from '../utils/entity-utils';
import {
  groupMentionRenameSourcesByType,
  mentionRenameSourceTypeLabelKey,
  type MentionRenameImpactSource,
} from '../utils/mention-rename';

type MentionRenameImpactListProps = {
  sources: MentionRenameImpactSource[];
  projectId: string | null | undefined;
};

export const MentionRenameImpactList: React.FC<MentionRenameImpactListProps> = ({
  sources,
  projectId,
}) => {
  const { t } = useLocale();
  const groups = useMemo(() => groupMentionRenameSourcesByType(sources), [sources]);

  return (
    <div className="max-h-48 overflow-y-auto rounded-md border border-border bg-muted/30 px-3 py-2">
      <ul className="space-y-2 text-sm text-muted-foreground">
        {groups.map((group) => (
          <li key={group.sourceType}>
            <div className="font-medium text-foreground">
              {t(mentionRenameSourceTypeLabelKey(group.sourceType))}
            </div>
            <ul className="mt-1 list-disc space-y-1 pl-5">
              {group.sources.map((source) => {
                const href = projectId
                  ? entityToHref(
                      {
                        type: source.sourceType,
                        id: source.sourceId,
                        documentId: source.sourceDocumentId ?? undefined,
                        label: source.label,
                      },
                      projectId,
                    )
                  : '#';
                const canLink = Boolean(projectId) && href !== '#';
                return (
                  <li key={`${source.sourceType}:${source.sourceId}:${source.sourceDocumentId ?? ''}`}>
                    {canLink ? (
                      <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-foreground underline-offset-2 hover:underline"
                      >
                        {source.label}
                      </a>
                    ) : (
                      source.label
                    )}
                  </li>
                );
              })}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};
